import { useEffect, useState } from 'react';
import { toast } from 'sonner';

export const InternetStatusPopup = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [isManuallyClosed, setIsManuallyClosed] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setIsManuallyClosed(false); 
      toast.success("You are back online");
    };

    const handleOffline = () => {
      setIsOnline(false);
      setIsManuallyClosed(false);
    };

    if (!navigator.onLine) {
      setIsOnline(false);
    }

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  if (isOnline || isManuallyClosed) return null;

  return (
    <div style={styles.popup}>
      <span>No Internet Connection. Please check your network.</span>
      <button onClick={() => setIsManuallyClosed(true)} style={styles.closeBtn}>×</button>
    </div>
  );
};

const styles = {
  popup: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    backgroundColor: '#ff4d4f',
    color: '#fff',
    padding: '12px 16px',
    textAlign: 'center',
    fontWeight: 'bold',
    zIndex: 9999,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  closeBtn: {
    background: 'transparent',
    border: 'none',
    color: '#fff',
    fontSize: '20px',
    fontWeight: 'bold',
    cursor: 'pointer',
  },
};
